var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.6999 16.9C9.2999 16.4 8.9999 15.8 8.9999 15.1C8.9999 13.6 10.1999 12.4 11.6999 12.4C13.1999 12.4 14.3999 13.6 14.3999 15.1C14.3999 16.6 14.3999 15.6 14.2999 15.8L18.3999 17.9C18.8999 17.2 19.6999 16.8 20.5999 16.8C21.4999 16.8 21.1999 16.8 21.4999 17L26.1999 10.2V3.90002H3.3999V24.7L9.5999 16.9H9.6999Z",
    fill: "#00ADEE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8999 19.6C18.8999 20.6 19.6999 21.3 20.5999 21.3C21.4999 21.3 22.2999 20.5 22.2999 19.6C22.2999 18.7 21.4999 17.9 20.5999 17.9C19.6999 17.9 18.8999 18.7 18.8999 19.6Z",
    fill: "#00ADEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 15.1C13.5001 14.1 12.7001 13.4 11.8001 13.4C10.9001 13.4 10.1001 14.2 10.1001 15.1C10.1001 16 10.9001 16.8 11.8001 16.8C12.7001 16.8 13.5001 16 13.5001 15.1Z",
    fill: "#00ADEE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4002 17.5C23.0002 18 23.4002 18.7 23.4002 19.6C23.4002 21.1 22.2002 22.3 20.7002 22.3C19.2002 22.3 18.0002 21.1 18.0002 19.6C18.0002 18.1 18.0002 19.1 18.1002 18.9L14.0002 16.8C13.5002 17.5 12.7002 17.9 11.8002 17.9C10.9002 17.9 10.9002 17.8 10.5002 17.6L3.7002 26.2H26.3002V12.1L22.5002 17.6L22.4002 17.5Z",
    fill: "#00ADEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineActive);
export default __webpack_public_path__ + "static/media/line-active.ca5de2a2bc8871fa1b9bc0f2746e9c0c.svg";
export { ForwardRef as ReactComponent };